import { get, remove } from 'helpers/apiHelpers';
import types from 'helpers/constants';

export const fetchZones = () => dispatch =>
  get(
    '/zones?properties[]=name&properties[]=id&properties[]=goodSpeedIntegrationEnabled&properties[]=category&properties[category][]=id&properties[category][]=name',
    {
      pagination: false,
    }
    // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
  ).then(response => {
    dispatch({
      type: types.FETCH_ZONES,
      payload: {
        zones: response['hydra:member'],
      },
    });
    return response['hydra:member'];
  });

export const fetchZone = id => dispatch =>
  // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
  get(`/zones/${id}`).then(response => {
    dispatch({
      type: types.FETCH_ZONE,
      payload: {
        name: response.name,
      },
    });
    return response;
  });

export const removeZone = id => dispatch =>
  // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
  remove(`/zones/${id}`).then(() => {
    dispatch({
      type: types.REMOVE_ZONE,
      payload: {
        zoneId: id,
      },
    });
  });
